// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-BsTf","content":"styles_content__1QFM6","selectAll":"styles_selectAll__BFLhu"};